import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M11.1387 0C12.0038 0 12.8268 0.373376 13.3965 1.02441L16 4V6H17C18.6569 6 20 7.34315 20 9V13C20 14.6569 18.6569 16 17 16H16V17C16 18.6569 14.6569 20 13 20H7C5.34315 20 4 18.6569 4 17V16H3C1.34315 16 0 14.6569 0 13V9C0 7.34315 1.34315 6 3 6H4V3C4 1.34315 5.34315 0 7 0H11.1387ZM6 17C6 17.5523 6.44772 18 7 18H13C13.5523 18 14 17.5523 14 17V12H6V17ZM3 8C2.44772 8 2 8.44772 2 9V13C2 13.5523 2.44772 14 3 14H4V12C3.44772 12 3 11.5523 3 11C3 10.4477 3.44772 10 4 10H16C16.5523 10 17 10.4477 17 11C17 11.5177 16.6067 11.9438 16.1025 11.9951L16 12V14H17C17.5523 14 18 13.5523 18 13V9C18 8.44771 17.5523 8 17 8H3ZM7 2C6.44772 2 6 2.44772 6 3V6H14V4.75195L11.8916 2.3418C11.7017 2.12478 11.427 2 11.1387 2H7Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}